"use strict"; // import dotenv from "dotenv";
// dotenv.config();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var company_1 = require("./Company/company");

var user_1 = require("./User/user");

var NodeAuth =
/** @class */
function () {
  function NodeAuth() {
    this.Company = new company_1.Company();
    this.User = new user_1.User();
  }

  NodeAuth.prototype.setUrl = function (url) {
    this.Company.setUrl(url);
    this.User.setUrl(url);
  };

  return NodeAuth;
}();

exports.default = new NodeAuth();